
/**
 * Find the direct child node of. Traverses up the parent chain
 * until it finds the parent, and returns the children underneath
 * the target belongs to.
 *
 * @param parent
 * @param target
 */
export function findDirectChildElementOf(parent: Node | undefined, target: Node | null): Element | null {
    if (!parent || !target) {
        return null
    }

    let actualChild: Node | null = target
    while (actualChild && actualChild != document.body && actualChild.parentNode != parent) {
        actualChild = actualChild.parentNode
    }

    if (actualChild?.parentNode != parent) {
        return null
    }

    return <Element>actualChild
}

/**
 * Finds the index where this item belongs as an element in the parent.
 * @param element
 */
export function getDirectChildIndex(element: Element) {
    let i = 0;
    let itElement: Element | null = element


    while((itElement=itElement.previousElementSibling) != null) ++i;

    return i;
}

export function isDomChild(parent: Node, child: Node|null): boolean {
  while (child && child.parentElement != child) {
    if (child == parent) {
      return true
    }

    child = child.parentElement;
  }

  return false
}
